import React, { useEffect, useState } from "react";
import axios from "axios";

function TestRout() {
  const [qr, setQr] = useState("");
  const [status, setStatus] = useState(false);
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const interval = setInterval(async () => {
      const res = await axios.get("http://localhost:5000/qr");
      setQr(res.data.qr);

      const statusRes = await axios.get("http://localhost:5000/status");
      setStatus(statusRes.data.ready);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const sendMessage = async () => {
    await axios.post("http://localhost:5000/send", {
      number,
      message,
    });
    alert("Message Sent");
  };

  return (
    <div>
      {!status && qr && (
        <>
          <h3>Scan QR with WhatsApp</h3>
          <img src={qr} alt="QR Code" />
        </>
      )}

      {status && (
        <>
          <h3>WhatsApp Connected</h3>
          <input
            placeholder="923001234567"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
          />
          <input
            placeholder="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <button onClick={sendMessage}>Send</button>
        </>
      )}
    </div>
  );
}

export default TestRout;